import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "../lib/api";

const LINKS = [
  ["catalog", "Accounts"],
  ["how-it-works", "How it works"],
  ["reviews", "Reviews"],
  ["faq", "FAQ"],
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${
        scrolled || open ? "border-b border-white/10 bg-[#07070b]/75 backdrop-blur-xl" : "border-b border-transparent bg-[#07070b]/30 backdrop-blur-md"
      }`}
    >
      <nav className="mx-auto flex h-[72px] max-w-[1440px] items-center justify-between px-5 md:px-10">
        <button onClick={() => go("top")} data-testid="nav-brand-logo" aria-label="OGM home">
          <Logo />
        </button>
        <div className="hidden items-center gap-9 md:flex">
          {LINKS.map(([id, label]) => (
            <button
              key={id}
              onClick={() => go(id)}
              data-testid={`nav-${id}-link`}
              className="group relative font-mono text-xs uppercase tracking-[0.2em] text-slate-300 transition-colors hover:text-white"
            >
              {label}
              <span className="absolute -bottom-1.5 left-0 h-px w-full origin-left scale-x-0 bg-violet-300 transition-transform duration-300 group-hover:scale-x-100" />
            </button>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <Link to="/account" data-testid="nav-find-order-link" className="hidden font-mono text-xs uppercase tracking-[0.2em] text-slate-300 transition-colors hover:text-white md:block">My orders</Link>
          <button
            onClick={() => go("catalog")}
            data-testid="nav-shop-button"
            className="hidden rounded-full bg-[#a259ff] px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-widest text-black transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_30px_rgba(162,89,255,0.55)] sm:block"
          >
            Shop now
          </button>
          <button className="text-white md:hidden" onClick={() => setOpen((v) => !v)} data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </nav>
      {open && (
        <div className="border-t border-white/10 px-5 pb-6 md:hidden" data-testid="nav-mobile-menu">
          {LINKS.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} className="block w-full py-3 text-left font-display text-4xl uppercase text-white" data-testid={`nav-mobile-${id}-link`}>
              {label}
            </button>
          ))}
          <Link to="/account" className="mt-2 block font-mono text-sm uppercase tracking-widest text-[#e9d5ff]" data-testid="nav-mobile-find-order-link">My orders — sign in</Link>
          <Link to="/admin" className="mt-4 block font-mono text-xs uppercase tracking-widest text-slate-400" data-testid="nav-admin-link">Owner login</Link>
        </div>
      )}
    </header>
  );
};
